import { getToken } from '@/utils/auth'

const API_PREFIX = '/prod-api'

async function request(path, options = {}) {
  const headers = {
    Accept: 'application/json',
    ...(options.headers || {})
  }
  const token = getToken()
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }
  if (options.body !== undefined && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json'
  }

  const response = await fetch(`${API_PREFIX}${path}`, {
    ...options,
    headers
  })
  const contentType = response.headers.get('content-type') || ''
  const result = contentType.includes('application/json')
    ? await response.json()
    : {}

  if (!response.ok || Number(result.code) !== 200) {
    throw new Error(result.msg || `请假申请请求失败：${response.status}`)
  }

  return result
}

function queryString(params) {
  const query = new URLSearchParams()
  Object.keys(params || {}).forEach(key => {
    const value = params[key]
    if (value !== undefined && value !== null && value !== '') {
      query.set(key, value)
    }
  })
  const value = query.toString()
  return value ? `?${value}` : ''
}

export function listLeaveProcess(params = {}) {
  return request(`/right/leave/process/list${queryString(params)}`)
}

export function listMyLeaveApplication(params = {}) {
  return request(`/right/leave/application/my-list${queryString(params)}`)
}

export function listLeaveTodo(params = {}) {
  return request(`/right/leave/application/todo${queryString(params)}`)
}

export function getMyLeaveApplication(id) {
  return request(`/right/leave/application/my/${id}`)
}

export function getLeaveApplication(id) {
  return request(`/right/leave/application/${id}`)
}

export function getTodoLeaveApplication(id) {
  return request(`/right/leave/application/todo/${id}`)
}

export function addLeaveApplication(data) {
  return request('/right/leave/application', {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

export function withdrawLeaveApplication(id) {
  return request(`/right/leave/application/${id}/withdraw`, { method: 'POST' })
}

export function approveLeaveApplication(id, data) {
  return request(`/right/leave/application/${id}/approve`, {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

export function getLeaveDutyOptions(startDate, endDate) {
  return request(`/right/leave/application/duty-options${queryString({ startDate, endDate })}`)
}

export async function uploadLeaveAttachment(file) {
  const formData = new FormData()
  formData.append('file', file)
  const headers = { Accept: 'application/json' }
  const token = getToken()
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  const response = await fetch(`${API_PREFIX}/common/upload`, {
    method: 'POST',
    headers,
    body: formData
  })
  const result = await response.json().catch(() => ({}))
  if (!response.ok || Number(result.code) !== 200) {
    throw new Error(result.msg || `附件上传失败：${response.status}`)
  }
  return result
}
